import { Link as RouterLink, useLocation } from 'react-router-dom';
// @mui
import { Box, Grid, Link, Stack, Divider, Container, Typography } from '@mui/material';
// routes
import { PATH_PAGE } from '../../routes/paths';
// _mock
// components
import Logo from '../../components/minimal/logo';
import { useLocales } from '../../locales';
import { getMarketPlaceName, getMarketPlaceTermsOfServiceAndPp } from '../../utils/market';
import { Button } from '@mui/material';
import Iconify from '../../components/minimal/iconify';

// ----------------------------------------------------------------------
const [PATH_TO_TOS, PATH_TO_PP] = getMarketPlaceTermsOfServiceAndPp();

const LINKS = [
  {
    headline: 'קיצורים',
    children: [
      {
        name: 'סורק כרטיסים Apple App Store', href: "https://apps.apple.com/il/app/nimi-events-and-ticketing/id6468482526", target: '_blank',
        icon: 'logos:apple-app-store',
      },
      {
        name: 'סורק כרטיסים Google Play Store ',
        href: "https://play.google.com/store/apps/details?id=com.nimi.nimi&hl=en_US",
        target: '_blank',
        icon: 'logos:google-play-icon'
      },
    ],
  },
  {
    headline: 'תקנון',
    children: [
      { name: 'תנאי שימוש', href: PATH_TO_TOS, target: '_blank' },
      { name: 'מדיניות פרטיות', href: PATH_TO_PP, target: '_blank' },
    ],
  },
  {
    headline: 'צור קשר',
    children: [
      { name: 'דברו איתנו', href: "mailto:hagit@nimi.co.il" },
      { name: 'הכתובת שלנו', href: `https://www.google.com/maps/search/mind-space רמת גן`, target: '_blank' },
    ],
  },
];

// ----------------------------------------------------------------------

export default function Footer() {
  const { pathname } = useLocation();
  const { translate } = useLocales();
  const name = getMarketPlaceName();
  const title = translate(name + '.home.title');
  const subtitle = translate(name + '.home.subtitle');
  const isHome = pathname === '/';


  // const simpleFooter = (
  //   <Box
  //     component="footer"
  //     sx={{
  //       py: 5,
  //       textAlign: 'center',
  //       position: 'relative',
  //       bgcolor: 'background.default',
  //     }}
  //   >
  //     <Container>
  //       <Logo sx={{ mb: 1, mx: 'auto' }} />

  //       <Typography variant="caption" component="div">
  //         © All rights reserved
  //         <br /> made by<Box sx={{ color: "primary.main", display: "inline" }} > Nimi</Box>
  //       </Typography>
  //     </Container>
  //   </Box>
  // );

  const mainFooter = (
    <Box
      component="footer"
      sx={{
        position: 'relative',
        bgcolor: 'background.default',
      }}
    >
      <Divider />

      <Container sx={{ pt: 10 }}>
        <Grid
          container
          justifyContent={{
            xs: 'center',
            md: 'space-between',
          }}
          sx={{
            textAlign: {
              xs: 'center',
              md: 'left',
            },
          }}
        >
          <Grid item xs={8} md={3}>
            <Typography variant="h5" sx={{ pr: { md: 5 } }}>
              {name}
            </Typography>
            <Typography variant="h6" sx={{ pr: { md: 5 } }}>
              {title}
            </Typography>
            <Typography variant="body2" sx={{ pr: { md: 5 } }}>
              {subtitle}
            </Typography>

            <Stack
              spacing={1}
              direction="row"
              justifyContent={{ xs: 'center', md: 'flex-start' }}
              sx={{
                mt: 5,
                mb: { xs: 5, md: 0 },
              }}
            >
              {/*{_socials.map((social) => (*/}
              {/*  <IconButton key={social.name}>*/}
              {/*    <Iconify icon={social.icon} />*/}
              {/*  </IconButton>*/}
              {/*))}*/}
            </Stack>
          </Grid>

          <Grid item xs={12} md={7}>
            <Stack
              spacing={5}
              justifyContent="space-between"
              direction={{ xs: 'column', md: 'row' }}
            >
              {LINKS.map((list) => (
                <Stack
                  key={list.headline}
                  spacing={2}
                  alignItems={{ xs: 'center', md: 'flex-start' }}
                >
                  <Typography component="div" variant="overline">
                    {list.headline}
                  </Typography>

                  {list.children.map((link) => (
                    <Link
                      target={link.target}
                      key={link.name}
                      component={RouterLink}
                      to={link.href}
                      color="inherit"
                      variant="body2"
                    >
                      <Stack direction="row" gap={1}>
                        {link.icon && <Iconify icon={link.icon} />}
                        <span>{link.name} </span>
                      </Stack>
                    </Link>
                  ))}
                </Stack>
              ))}
            </Stack>
          </Grid>
        </Grid>

        <Typography
          variant="caption"
          component="div"
          sx={{
            mt: 10,
            pb: 5,
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          © 2021. All rights reserved
        </Typography>
      </Container>
    </Box>
  );

  return mainFooter;
}
